import { Box } from "@outschool/backpack";
import { measurePerformance } from "@outschool/ui-analytics";
import {
  ActivityListingPhoto,
  ListingPhoto_ActivityFragment,
} from "@outschool/ui-components-classroom";
import React from "react";

/**
 * Header photo of the search results gallery experiment listing card.
 * Uses CDP aspect ratio (344:179, approximately 1.92:1).
 */
export default function HeaderPhoto({
  activity,
  listingIndex,
}: {
  activity: ListingPhoto_ActivityFragment;
  listingIndex: number;
}) {
  return (
    <Box
      sx={{
        width: "100%",
        overflow: "hidden",
        borderRadius: "0.5em",
      }}
    >
      <ActivityListingPhoto
        activity={activity}
        useOriginalAspectRatio
        onLoad={
          listingIndex === 0
            ? () => {
                measurePerformance("os-page-load", { source: "image" });
              }
            : undefined
        }
      />
    </Box>
  );
}
